<template>
  <div>
    <el-menu
      unique-opened
      :default-active="daohang"
      class="el-menu-vertical-demo menus"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :router="true"
      background-color="#222d32"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <div v-for="(group, index) in menuList" :key="index">
        <el-submenu v-if="group.list.length > 1" :index="group.mc">
          <template slot="title">
            <i :class="group.tb"></i>
            <span class="menutitle">{{ group.mc }}</span>
            <span style="float:right;margin-right:20px">
              <el-tag v-if="group.sftj" effect="dark" type="primary" size="mini"
                >荐</el-tag
              >
              <el-tag
                v-if="group.sfnew"
                effect="dark"
                type="success"
                size="mini"
                >新</el-tag
              >
              <el-tag v-if="group.sfhot" effect="dark" type="danger" size="mini"
                >热</el-tag
              >
            </span>
          </template>
          <div v-for="(child, index) in group.list" :key="index">
            <el-menu-item
              :index="child.path"
              @click="sessionSet(child)"
              :disabled="disabled"
            >
              <i :class="child.tb"></i>
              <span class="menutitle">{{ child.name }}</span>
              <span style="float:right">
                <el-tag
                  v-if="child.sftj"
                  effect="dark"
                  type="primary"
                  size="mini"
                  >荐</el-tag
                >
                <el-tag
                  v-if="child.sfnew"
                  effect="dark"
                  type="success"
                  size="mini"
                  >新</el-tag
                >
                <el-tag
                  v-if="child.sfhot"
                  effect="dark"
                  type="danger"
                  size="mini"
                  >热</el-tag
                >
              </span>
            </el-menu-item>
          </div>
        </el-submenu>
        <div v-else>
          <el-menu-item
            :index="group.path"
            @click="sessionSet(group)"
            :disabled="disabled"
          >
            <i :class="group.tb"></i>
            <span class="menutitle">{{ group.mc }}</span>
            <span style="float:right">
              <el-tag v-if="group.sftj" effect="dark" type="primary" size="mini"
                >荐</el-tag
              >
              <el-tag
                v-if="group.sfnew"
                effect="dark"
                type="success"
                size="mini"
                >新</el-tag
              >
              <el-tag v-if="group.sfhot" effect="dark" type="danger" size="mini"
                >热</el-tag
              >
            </span>
          </el-menu-item>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      daohang: "",
      isCollapse: false,
      disabled: true,
      menuList: [],
      chanpins: {}
    };
  },

  created() {
    this.daohang = this.$route.path;

    //显示和排序问题
    //读取list全部列表，控制显示内容和排序
    this.$AJAX.geturl("/api/Fun/GetChanPinLeiBie").then(x => {
      if (x.data.success) {
        //group by

        //xs = 1
        //px = 顺序
        //分组    [{list,px,mc,sftj,sfnew,sfhot},{},{}] 顺序

        let groups = [];
        //只要显示的

        x.data.data
          .filter(o => o.xs == 1)
          .map(o => {
            let name = o.fl || o.name;
            let current = groups.find(t => t.mc == name);

            //更新产品类别
            let cplbs = this.$o_cplb.filter(t => t.value == o.bm);
            if (cplbs && cplbs.length > 0) {
              cplbs[0].label = o.name;
              cplbs[0].allowed = true;
            }

            //判断类型
            if (o.lx == 1) {
              //价格表
              o.path = `/otherchanpinjiage/${o.bm}`;
            }
            if (o.lx == 2) {
              //价格表
              o.path = `/otherchanpin/${o.bm}`;
            }

            this.chanpins[o.path] = o.name;
            //显示标题
            if (o.path == this.daohang) {
              this.$WEB.$STORE.state.CurrentTitle = o.name;
            }

            if (current) {
              //存储子对象
              current.list.push(o);
              if (o.px < current.px) current.px = o.px;
              current.sftj = current.sftj || o.sftj;
              current.sfnew = current.sfnew || o.sfnew;
              current.sfhot = current.sfhot || o.sfhot;

              current.list.sort((a, b) => a.px - b.px);
            } else {
              current = {
                list: [],
                mc: name,
                px: 999,
                sftj: 0,
                sfnew: 0,
                sfhot: 0,
                tb: ""
              };
              current.list.push(o);
              current = { ...current, ...o };
              groups.push(current);
            }
          });

        //从小到大排序
        groups.sort((a, b) => a.px - b.px);

        this.menuList = groups;

        this.daohang = this.menuList[0].path;

        sessionStorage.setItem("daohang", this.daohang); //存菜单

        this.$router.push(this.menuList[0].path);

        //转到第一个
        this.disabled = false;
      }
    });
  },
  watch: {
    listenshow() {
      this.isCollapse = this.$store.state.showFooter;
    },
    $route(to, from) {
      this.daohang = to.path;

      this.$WEB.$STORE.state.CurrentTitle = this.chanpins[to.path];
    }
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    sessionSet(list) {
      this.$WEB.$STORE.state.CurrentTitle = list.name;
    }
  },
  computed: {
    listenshow() {
      return this.$store.state.showFooter;
    }
  }
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 270px;
}
.el-submenu .el-menu-item {
  padding: 0 20px;
}
.zizhu {
  background: #e5e9f2;
  font-size: 16px;
}

.menutitle {
  margin-left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/shouyeZujian/cebianlan.vue